import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import { CardHeaderRow } from "./CardHeaderRow";
import { NumberInputRow } from "./NumberInputRow";
import styles from "../unit-threshold-setup.module.scss";

interface ThresholdCardProps {
	reminderOn: boolean;
	thresholdInput: number | null;
	thresholdSaved: boolean;
	isSaving: boolean;
	onToggleReminder: (val: boolean) => void;
	onThresholdChange: (val: number) => void;
	onSave: () => void;
}

export const ThresholdCard = ({
	reminderOn,
	thresholdInput,
	thresholdSaved,
	isSaving,
	onToggleReminder,
	onThresholdChange,
	onSave,
}: ThresholdCardProps) => {
	const canSave = reminderOn && thresholdInput != null && thresholdInput > 0;

	return (
		<CardFrame>
			<CardHeaderRow
				title="Low Threshold Reminder"
				subtitle="Get notified when your unit balance is low"
				isOn={reminderOn}
				onToggle={onToggleReminder}
			/>
			{reminderOn && (
				<div className={styles.cardBody}>
					<NumberInputRow
						label="Unit Threshold Value"
						value={thresholdInput}
						unit="kWh"
						step={1}
						isSaved={thresholdSaved}
						isSaving={isSaving}
						canSave={canSave}
						onChange={onThresholdChange}
						onSave={onSave}
						plusMinus={false}
					/>
				</div>
			)}
		</CardFrame>
	);
};
